module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Jack Compton’s Luck")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("DON’T MISS THESE OTHER"), _c('br'), _vm._v("\nNOVELS AVAILABLE NOW:")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("#943 THE DIAMONDS OF WELBOURNE MANOR—Diane Gaston, Deb Marlow, Amanda McCabe")])])])]), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_vm._v("Welcome to Welbourne Manor! In this lush family home a Regency house party is in full swing. Join three beautiful sisters, Justine, Annalise and Charlotte, as they each discover something more precious than diamonds—husbands!")])]), _c('br'), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("#944 HIS FORBIDDEN LIAISON—Joanna Maitland")])])])]), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_vm._v("Notorious Jack Aikenhead has never wanted for female company…until he meets feisty Marguerite Grolier, and realizes she’s the "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("only")])]), _vm._v(" woman he needs. Although they have been thrown together by circumstance, the reckless rake transforms into an honorable knave, for love!")])]), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Third in The Aikenhead Honors trilogy—three gentlemen spies: bound by duty, undone by women!")])])])]), _c('br'), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("#945 THE CATTLEMAN’S UNSUITABLE WIFE—Pam Crooks")])])])]), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_vm._v("Ruthless Montana rancher Trey Wells has never met a woman who ignites his passion so much as exotic beauty Zurina Vasco. Despite all that separates them, can Trey give Zurina the love, respectability and true home she deserves?")])]), _c('br'), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("#946 THE BORDER LORD—Sophia James")])])])]), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_vm._v("Laird Lachlan Kerr knows the safety of his home depends on his betrothal to Grace Stanton, but their passionate embraces are an unexpected pleasure! Lach is used to betrayal at every turn, but Grace’s faith in him is powerfully seductive…")])]), _c('br'), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("#259 MAJOR WESTHAVEN’S UNWILLING WARD—Emily Bascom")])])])]), _c('p', {
    staticClass: "paraCenter"
  }, [_c('span', [_vm._v("Spirited, independent Liliana Pevensey is horrified to learn her late brother has placed her under the guardianship of brooding Major Daniel Westhaven! Battle-scarred Daniel clearly disapproves of her—so why does Lily find herself longing for his touch?")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page06"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ab046b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jackcomptonsluck_fm03.vue
// module id = 72
// module chunks = 0